import {Header} from "../../../../components/header";
// @ts-ignore
import globalStyle from "../style.module.scss";
import {Footer} from "../../../../components/footer";

export const UmweltplakettePage = () => {
    return (
        <>
            <Header/>
            <div className={globalStyle.detail_service}>
                <h1 className={globalStyle.headline}>Umweltplakette</h1>

                <div className={globalStyle.text_container}>
                    <p>Die Umweltplakette kann bei uns bezogen werden.</p>
                </div>
            </div>

            <Footer/>
        </>
    )
}